"use strict";

require("../../util/GlobalScript.js");

module.exports = require("./form-text-field");